<router-outlet></router-outlet>
<!-- <footer style="position: fixed; bottom: 0; right: 0; padding: 10px; background: rgba(255, 255, 255, 0.8);font-size: 12px;">
    <app-version></app-version>
</footer> -->